"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispenserUploadValidationSchema = exports.dispenserValidationSchema = exports.rowValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const types_1 = require("@framework/types");
exports.rowValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
    tokenType: (0, yup_1.mixed)().oneOf(Object.values(types_1.TokenType)).required("form.validations.valueMissing"),
    address: yup_rules_eth_1.addressValidationSchema,
    tokenId: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    amount: yup_rules_eth_1.bigNumberValidationSchema,
});
exports.dispenserValidationSchema = (0, yup_1.object)().shape({
    rows: (0, yup_1.array)().of(exports.rowValidationSchema).required("form.validations.valueMissing"),
});
exports.dispenserUploadValidationSchema = (0, yup_1.object)().shape({
    files: (0, yup_1.array)().min(1, "form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map